export const isAuthenticated = () =>
  localStorage.getItem("@token/mademil") !== null &&
  localStorage.getItem("@login/mademil") !== null;
